import React, { Component } from 'react';
import UpIcon from './assets/ok-status-icon.jsx';
import DownIcon from './assets/red-check.jsx';
import IncidentIcon from './assets/incident.jsx';
import MaintenanceIcon from './assets/maintenance.jsx';
import { Link, withRouter } from 'react-router-dom';
import './styles.scss';
import {
  formatText,
  formatDateAndTime,
  getMaintenanceStatus,
  getTimeAgo
} from '../utils/index';

const allOngoingIncidents = (incidents) => {
  const ongoingIncidents = incidents.filter((incident) => {
    if (incident.type === 'incident' || incident.type === 'outage') {
      if (!!incident.updates[0] && incident.updates[0].type.toLowerCase() !== 'resolved') {
        return true;
      }
    }

    if (incident.type === 'maintenance') {
      const maintenanceStatus = getMaintenanceStatus(incident.date, incident.endDate, 0);
      if (maintenanceStatus === 'In Progress' || maintenanceStatus === 'Upcoming') {
        return true;
      }
    }
  });

  return ongoingIncidents;
}

const getPriorizedIncident = (incidents) => {
  incidents.sort((a, b) => {
    const key1 = new Date(a.date);
    const key2 = new Date(b.date);

    if (key1 < key2) {
      return -1;
    } else if (key1 == key2) {
      return 0;
    } else {
      return 1;
    }
});
  const outage = incidents.find(incident => incident.type === 'outage');
  if (!!outage) {
    return outage;
  }

  const incident = incidents.find(incident => incident.type === 'incident');
  if (!!incident) {
    return incident;
  }
  
  const ongoingMaintenance = incidents.find(incident => (incident.type === 'maintenance') && getMaintenanceStatus(incident.date, incident.endDate, 0) === 'In Progress');
  if (!!ongoingMaintenance) {
    return ongoingMaintenance;
  }
  
  const upcomingMaintenance = incidents.find(incident => (incident.type === 'maintenance') && getMaintenanceStatus(incident.date, incident.endDate, 0) === 'Upcoming');
  if (!!upcomingMaintenance) {
    return upcomingMaintenance;
  }
}

const getTopLevelIcon = (incident) => {
  if (incident.type === 'outage') {
    return DownIcon;
  }
  
  if (incident.type === 'incident') {
    return IncidentIcon;
  }
  
  if (incident.type === 'maintenance') {
    return MaintenanceIcon;
  }

  return UpIcon;
}

const getTopLevelContent = (incidents) => {
  const ongoingIncidents = allOngoingIncidents(incidents);
  const priorizedIncident = getPriorizedIncident(ongoingIncidents);
  if (!priorizedIncident) {
    return { title: '', text: '', incidentId: '' };
  }

  const mostRecentUpdate = priorizedIncident.updates[0];
  const title = priorizedIncident.title;
  const text = mostRecentUpdate.text;

  const Icon = getTopLevelIcon(priorizedIncident);

  return {
    title,
    text,
    incidentId: priorizedIncident.uuid,
    postedAt: mostRecentUpdate.UTCTime,
    Icon
  };
}

const getIcon = (indicator) => {
  if (indicator === 'up') {
    return UpIcon;
  }
  
  if (indicator === 'down') {
    return DownIcon;
  }
  
  if (indicator === 'maintenance') {
    return MaintenanceIcon;
  }
  
  if (indicator === 'partialoutage') {
    return IncidentIcon;
  }
}

const getMostRecentIncidentDate = (incidents) => {
  const mostRecentIncident = incidents[0];
  return getTimeAgo(mostRecentIncident.updates[0].UTCTime);
}


class TopLevelStatus extends Component {
  isIncidentView() {
    const { pathname } = window.location;
    if (pathname.includes('/history/')) {
      return true;
    }
    return false;
  }

  render() {
    const { incidents, topLevelStatus } = this.props;

    const topLevelContent = getTopLevelContent(incidents, topLevelStatus);

    const hasOngoingIncident = !!topLevelContent && !!topLevelContent.title && topLevelContent.title.length > 0;
    if (!hasOngoingIncident) {
      topLevelContent.title = topLevelStatus.status;
      topLevelContent.Icon = getIcon(topLevelStatus.indicator);
    }
    const hasIncidents = incidents.length > 0;

    const TopLevelIcon = topLevelContent.Icon;

    return(
      <div className="whitebox top-level-status-wrapper">
        <div className="top-level-status">
          {/* <img className="top-level-status-icon" width="38px" height="38px" src={topLevelContent.icon} /> */}
          <div width="38px" height="38px" style={{ minWidth: '38px', width: '38px', height: '38px' }}>
            <TopLevelIcon height="100%" width="100%" />
          </div>
          <div className="status">
            <span className="title">{topLevelContent.title}</span>
            {!!topLevelContent.text && <span>
              <span className="last-incident">
                <span dangerouslySetInnerHTML={{ __html: formatText(topLevelContent.text) }} />
                <div className="posted-at"> Last update: {formatDateAndTime(topLevelContent.postedAt)}</div>
              </span>
            </span>}
            {!this.isIncidentView() && hasOngoingIncident && <span className="read-more"><a href={`/history${!!topLevelContent.incidentId ? '/' + topLevelContent.incidentId : ''}`}>Read more <span className="arrow-right">→</span></a></span>}
            {!hasOngoingIncident && hasIncidents && <span className="read-more"><Link to={{
              pathname: '/history',
              statuspage: this.props.statuspage
            }}>Last incident {getMostRecentIncidentDate(incidents)} <span className="arrow-right">→</span></Link></span>}
            {!hasOngoingIncident && !hasIncidents && <span className="read-more">No recent incident</span>}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(TopLevelStatus);
